import { createContext, useContext } from "react";

// Valori "ambiente" della pagina evento/torneo: stabili per tutta la durata
// della vista e richiesti da tutto il sottoalbero (pannelli stage, tabelle
// match, liste, ecc.). Prima venivano passati come props identiche attraverso
// 5-6 livelli (prop drilling); ora li espone questo Context.
export interface TournamentEventContextValue {
  canManage: boolean;
  enableCalendar: boolean;
  tournamentName: string;
  // Callback da invocare dopo aver salvato un match/risultato per ricaricare i
  // dati della competizione.
  onResultSaved: () => Promise<void> | void;
}

const TournamentEventContext = createContext<TournamentEventContextValue | null>(null);

export const TournamentEventProvider = TournamentEventContext.Provider;

export const useTournamentEvent = (): TournamentEventContextValue => {
  const value = useContext(TournamentEventContext);
  if (!value) {
    throw new Error("useTournamentEvent deve essere usato dentro un TournamentEventProvider");
  }
  return value;
};
